function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_00000094619160661896516760000017926511040893069981_);}\n\t.st2{fill:url(#SVGID_00000161591643746476402700000006496139725155235201_);}\n\t.st3{fill:url(#SVGID_00000009550182486099646780000010724931474712196020_);}\n\t.st4{fill:url(#SVGID_00000170275025499005292440000004169686898551208877_);}\n\t.st5{fill:url(#SVGID_00000001664312021462201630000012584682264468606117_);}\n\t.st6{fill:url(#SVGID_00000084510260555665179210000017718636626091252358_);}\n\t.st7{fill:url(#SVGID_00000007394590777356678000000006679629866016010634_);}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M8.58,0.02C4.31,0.02,0,2.41,0,7.75v4.87c0,0.64,0.52,1.17,1.17,1.17c0.62,0,1.14-0.54,1.14-1.17V7.75 c0-3.56,3.15-5.42,6.27-5.42c0.64,0,1.17-0.52,1.17-1.17C9.75,0.52,9.23,0.02,8.58,0.02"
});

function SvgLogoEsteso(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 104 13.8",
    style: {
      enableBackground: "new 0 0 104 13.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -5.1875,
    y1: 5.6282,
    x2: 106.8249,
    y2: 19.7985
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F29A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0151,
    style: {
      stopColor: "#4F29A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF0038"
    }
  })), _ref3, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000029010236258244401200000007104193002398467456_",
    gradientUnits: "userSpaceOnUse",
    x1: -4.3769,
    y1: -0.7797,
    x2: 107.6355,
    y2: 13.3905
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F29A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0151,
    style: {
      stopColor: "#4F29A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF0038"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000029010236258244401200000007104193002398467456_)"
    },
    d: "M52.96,0.02c-0.64,0-1.17,0.52-1.17,1.17 v4.87c0,5.34,4.31,7.73,8.58,7.73c0.66,0,1.17-0.5,1.17-1.14c0-0.64-0.52-1.17-1.17-1.17c-3.12,0-6.27-1.86-6.27-5.42V1.18 C54.1,0.55,53.58,0.02,52.96,0.02"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000090285039746114529260000006006451791188555437_",
    gradientUnits: "userSpaceOnUse",
    x1: -4.9936,
    y1: 4.0952,
    x2: 107.0188,
    y2: 18.2655
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F29A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0151,
    style: {
      stopColor: "#4F29A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF0038"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000090285039746114529260000006006451791188555437_)"
    },
    d: "M23.79,5.47C22.94,1.43,19.65,0,17.09,0 c-0.49,0-0.98,0.05-1.46,0.15c-3.72,0.78-6.1,4.44-5.32,8.16c0.67,3.17,3.5,5.47,6.73,5.47c0.48,0,0.95-0.05,1.42-0.15l0.07-0.01 c0.99-0.21,2.35-0.49,3.84-2.01c0.43-0.43,0.68-1.1,0.26-1.64c-0.23-0.29-0.6-0.48-0.97-0.48c-0.17,0-0.42,0.04-0.62,0.25 c-1.15,1.14-2.29,1.48-3.05,1.64c-0.31,0.07-0.63,0.1-0.95,0.1c-1.59,0-3.1-0.86-3.93-2.24l-0.19-0.31l0.35-0.07l9.6-2.02 C23.52,6.69,23.92,6.1,23.79,5.47 M20.85,4.9l-8.04,1.69l-0.35,0.07l0.05-0.36c0.26-1.93,1.71-3.5,3.61-3.9 c0.34-0.07,0.69-0.11,1.04-0.11c1.69,0,3.09,0.81,3.86,2.23l0.16,0.3L20.85,4.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000051356386838438089500000005676835134147105675_",
    gradientUnits: "userSpaceOnUse",
    x1: -3.7306,
    y1: -5.8886,
    x2: 108.2818,
    y2: 8.2816
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F29A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0151,
    style: {
      stopColor: "#4F29A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF0038"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000051356386838438089500000005676835134147105675_)"
    },
    d: "M103.98,5.47C103.13,1.43,99.84,0,97.28,0 c-0.49,0-0.98,0.05-1.46,0.15c-1.8,0.38-3.35,1.44-4.35,2.97c-1,1.54-1.35,3.38-0.97,5.18c0.67,3.17,3.5,5.47,6.73,5.47 c0.48,0,0.95-0.05,1.42-0.15l0.07-0.01c0.99-0.21,2.35-0.49,3.84-2.01c0.43-0.43,0.68-1.1,0.26-1.64c-0.23-0.29-0.6-0.48-0.97-0.48 c-0.17,0-0.42,0.04-0.62,0.25c-1.15,1.14-2.29,1.48-3.05,1.64c-0.31,0.07-0.63,0.1-0.95,0.1c-1.59,0-3.1-0.86-3.93-2.24l-0.19-0.31 l0.35-0.07l9.6-2.02C103.71,6.69,104.11,6.1,103.98,5.47 M101.03,4.9l-8.04,1.69l-0.35,0.07l0.05-0.36c0.26-1.93,1.71-3.5,3.61-3.9 c0.34-0.07,0.69-0.11,1.04-0.11c1.69,0,3.09,0.81,3.86,2.23l0.16,0.3L101.03,4.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000174573910221016091730000011649071885443831481_",
    gradientUnits: "userSpaceOnUse",
    x1: -4.7577,
    y1: 2.2308,
    x2: 107.2547,
    y2: 16.401
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F29A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0151,
    style: {
      stopColor: "#4F29A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF0038"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000174573910221016091730000011649071885443831481_)"
    },
    d: "M34.81,0.13 c-0.14-0.06-0.29-0.08-0.43-0.08c-0.47,0-0.9,0.3-1.07,0.76l-2.96,7.93l-0.24,0.63l-0.24-0.63l-2.99-7.94 c-0.18-0.46-0.6-0.76-1.07-0.76c-0.14,0-0.28,0.03-0.42,0.08c-0.29,0.1-0.52,0.31-0.65,0.58C24.62,1,24.61,1.32,24.72,1.62 L28.99,13c0.17,0.46,0.62,0.77,1.1,0.77c0.5,0,0.94-0.31,1.13-0.78l4.26-11.37c0.12-0.3,0.11-0.62-0.03-0.91 C35.33,0.44,35.1,0.23,34.81,0.13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000091723832374123998180000002084650435205317268_",
    gradientUnits: "userSpaceOnUse",
    x1: -4.5843,
    y1: 0.8599,
    x2: 107.4281,
    y2: 15.0301
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F29A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0151,
    style: {
      stopColor: "#4F29A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF0038"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000091723832374123998180000002084650435205317268_)"
    },
    d: "M43.07,0c-3.8,0-6.89,3.09-6.89,6.88 c0,3.8,3.09,6.89,6.89,6.89c3.8,0,6.89-3.09,6.89-6.89C49.95,3.09,46.86,0,43.07,0 M43.07,11.47c-2.52,0-4.58-2.05-4.58-4.58 c0-2.52,2.05-4.58,4.58-4.58c2.52,0,4.58,2.05,4.58,4.58C47.65,9.41,45.59,11.47,43.07,11.47"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000103251925273590689880000009914311245752295854_",
    gradientUnits: "userSpaceOnUse",
    x1: -4.1652,
    y1: -2.4528,
    x2: 107.8472,
    y2: 11.7175
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F29A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0151,
    style: {
      stopColor: "#4F29A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF0038"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000103251925273590689880000009914311245752295854_)"
    },
    d: "M63.49,0.03c-0.63,0-1.14,0.51-1.14,1.14 v7.14c0.03,3.04,2.49,5.49,5.49,5.49c3.02,0,5.49-2.45,5.52-5.47V1.17c0-0.63-0.51-1.14-1.14-1.14c-0.64,0-1.17,0.51-1.17,1.14 v7.11c0,1.77-1.44,3.21-3.21,3.21c-1.76,0-3.18-1.44-3.18-3.21V1.17C64.66,0.54,64.14,0.03,63.49,0.03"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000068677146075060043600000013903636765461449642_",
    gradientUnits: "userSpaceOnUse",
    x1: -3.969,
    y1: -4.0036,
    x2: 108.0433,
    y2: 10.1667
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F29A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0151,
    style: {
      stopColor: "#4F29A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF0038"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000068677146075060043600000013903636765461449642_)"
    },
    d: "M88.33,3.46 c-1.24-2.12-3.53-3.43-5.98-3.43c-3.78,0-6.86,3.09-6.86,6.89c0,3.8,3.08,6.89,6.86,6.89c2.36,0,4.53-1.18,5.79-3.15 c0.35-0.54,0.21-1.27-0.32-1.61c-0.18-0.11-0.4-0.17-0.62-0.17c-0.4,0-0.77,0.2-0.99,0.53c-0.84,1.32-2.28,2.11-3.85,2.11 c-2.48,0-4.58-2.1-4.58-4.58c0-2.52,2.05-4.58,4.58-4.58c1.64,0,3.16,0.88,3.97,2.29c0.21,0.34,0.6,0.56,1.02,0.56 c0.2,0,0.4-0.05,0.58-0.15C88.46,4.71,88.65,4,88.33,3.46"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoEsteso);
export default __webpack_public_path__ + "static/media/logo-esteso.548ceae0.svg";
export { ForwardRef as ReactComponent };